import clsx from 'clsx'
import React from 'react'
import {makeStyles, withStyles} from 'external/material'
import Grid from '@mui/material/Grid'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Checkbox from '@mui/material/Checkbox'
import MuiButton from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import {ArrowLeftIcon, ArrowRightIcon, DoubleArrowLeftIcon, DoubleArrowRightIcon} from '../resources/icons'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexGrow: 1,
  },
  left: {
    flexGrow: 1,
    width: 'calc(50% - 100px)',
  },
  right: {
    flexGrow: 1,
    width: 'calc(50% - 100px)',
  },
  checked: {
    backgroundColor: '#2ca5ec',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#2ca5ec',
    }
  },
  operations: {
    margin: '0 25px',
    display: 'flex',
    "& .button": {
      marginTop: 15,
      "&:first-child": {
        marginTop: 0
      }
    }
  },
  paper: {
    border: 'solid 1px #b0b0b0',
    boxShadow: 'none',
    height: 'calc(100% - 30px)',
    flexGrow: 1
  }
}))

const Button = withStyles(theme => ({
  root: {
    width: '50px',
    height: '50px',
    '&:hover': {
      transform: 'scale(1.02)'
    }
  },
  disabled: {
    opacity: 0.5
  },
}))(props => (
  <Grid item className="button">
    <MuiButton
      variant="outlined"
      size="small"
      {...props}
    >
      {props.children}
    </MuiButton>
  </Grid>
))

function ListElem (props) {
  const {index, label, checked, onClick} = props
  const labelId = `transfer-list-item-${index}-label`
  return (
    <ListItem role="listitem" button onClick={onClick} className={props.className}>
      <ListItemText id={labelId} primary={label} />
    </ListItem>
   )
}

export default function TransferList (props) {
  const classes = useStyles()
  const {
    left,
    right,
    checklist,
    LeftHeader,
    RightHeader,
    id = elem => typeof(elem) == 'object' ? elem.id : elem,
    label = elem => typeof(elem) == 'object' ? elem.label : elem,
    ListItem = ListElem,
    onChecked
  } = props

  const isChecked = elem => checklist[id(elem)]
  const isNotChecked = elem => !checklist[id(elem)]

  const createItem = (elem, index) => {
    const key = id(elem)
    const checked = checklist[key]
    return (<ListItem
        index={index}
        key={key}
        label={label(elem)}
        checked={checked}
        className={clsx({[classes.checked]: checked})}
        onClick={() => onChecked(key, !checked)}
    />)
  }

  function handleTransfer(source, sourceKey, sink, sinkKey, all) {
    return () => {
      const newSource = all ? [] : source.filter(isNotChecked)
      const newSink = sink.concat(all ? source : source.filter(isChecked))
      props.onTransfer({[sourceKey]: newSource, [sinkKey]: newSink})
    }
  }

  return (
    <Grid container className={classes.root}>
      <Grid item className={classes.left}>
        {LeftHeader && <LeftHeader />}
        <Paper className={classes.paper}>
          <List dense component="div" role="list">
            {left.map(createItem)}
          </List>
        </Paper>
      </Grid>
      <Grid item className={classes.operations}>
        <Grid container direction="column" justifyContent="center">
          <Button
            disabled={left.length == 0}
            onClick={handleTransfer(left, 'left', right, 'right', true)}
          >
            <DoubleArrowRightIcon />
          </Button>
          <Button
            disabled={left.find(isChecked) == undefined}
            onClick={handleTransfer(left, 'left', right, 'right')}
          >
            <ArrowRightIcon />
          </Button>
          <Button
            disabled={right.find(isChecked) == undefined}
            onClick={handleTransfer(right, 'right', left, 'left')}
          >
            <ArrowLeftIcon />
          </Button>
          <Button
            disabled={right.length == 0}
            onClick={handleTransfer(right, 'right', left, 'left', true)}
          >
            <DoubleArrowLeftIcon />
          </Button>
        </Grid>
      </Grid>
      <Grid item className={classes.right}>
        {RightHeader && <RightHeader/>}
        <Paper className={classes.paper}>
          <List dense component="div" role="list">
            {right.map(createItem)}
          </List>
        </Paper>
      </Grid>
    </Grid>
  );
}
